'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('react/jsx-runtime');
var styled = require('@emotion/styled');
var React = require('react');
var ui = require('../image/ui.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const Page404 = ({ src }) => {
  const [countdown, setCountdown] = React.useState(10);
  const interval = React.useRef(null);
  React.useEffect(() => {
    interval.current = setInterval(() => {
      setCountdown((countdown2) => countdown2 - 1);
    }, 1e3);
    return () => clearInterval(interval.current);
  }, []);
  React.useEffect(() => {
    if (countdown === 0) {
      clearInterval(interval.current);
      window.location.href = "/";
    }
  }, [countdown]);
  return /* @__PURE__ */ jsxRuntime.jsxs(WrapperPage, {
    children: [
      /* @__PURE__ */ jsxRuntime.jsx(ui.Image, {
        src
      }),
      /* @__PURE__ */ jsxRuntime.jsxs(StyledText, {
        children: [
          "Trang kh\xF4ng t\u1ED3n t\u1EA1i. B\u1EA1n s\u1EBD \u0111\u01B0\u1EE3c \u0111\u01B0a v\u1EC1 trang ch\u1EE7 sau ",
          countdown,
          "s"
        ]
      })
    ]
  });
};
Page404.displayName = "404";
const WrapperPage = styled__default["default"].div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 70vh;
`;
const StyledText = styled__default["default"].div`
  color: #848788;
  font-weight: 400;
`;

exports.Page404 = Page404;
